import React from "react";
import styles from "../../AddEditAutoImportConfigurationsModal.module.css";

interface GridItem {
  colSpan?: number;
  render: () => React.ReactNode;
}

interface FormGridProps {
  items: GridItem[];
}

//simple reusable form component used for formatting form inputs in a uniform way
export const FormGrid = ({ items }:FormGridProps) => {
  return (
    <div className={styles.formGrid}>
      {items.map(({ colSpan = 12, render }, index) => (
        <div key={index} style={{ gridColumn: `span ${colSpan}` }}>
          {render()}
        </div>
      ))}
    </div>
  );
};
